import {
  Calculator,
  CalendarDays,
  CalendarRange,
  CheckCircle,
  ChevronRight,
  Clock,
  DivideCircle,
  Plus,
  Truck,
} from "lucide-react";
import { useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import { useGetIftaQuery } from "../../redux/services/IftaComplianceService";
import IftaModal from "./IftaModal";
import { getQuarterDateRange, QUARTERS } from "../../helpers";
import { useGetTractorsQuery } from "../../redux/services/TractorsService";
import CustomPagination from "../../components/CustomPagination";
import Filter from "./Filter";
// import PageHeader from "../../components/PageHeader";

export default function IftaCompliance({ setQuery }) {
  const {
    currentPage,
    perPage,
    q,
    searchQuery,
    setSearchQuery,
    handlePageChange,
    handlePerPageChange,
    handleSearchChange,
    onSearchKeyHandler,
    handleSearchBy,
    searchBy,
  } = useLiveDataTable();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { data, isFetching, refetch } = useGetIftaQuery({
    pagination: `?page=${currentPage}&perPage=${perPage}`,
  });
  const filling = data?.response?.data?.data || [];
  const total = data?.response?.data?.total || 0;

  const { data: data2 } = useGetTractorsQuery({
    id: "tractors",
    pagination: `?page=1&perPage=1000`,
  });
  const tractors = data2?.response?.data?.data;
  const totalTrac = data2?.response?.data?.total;

  const handleCreate = (data) => {
    console.log("Creating IFTA Filing:", data);
    setShowModal(false);
  };
  const handleReportClick = (report) => {
    // console.log("Vehicle clicked:", report.vehicle);
    navigate(`/ifta-compliance-view/${report.id}`, {
      state: { vehicle: report.vehicle },
    });
  };
  const fillings = filling || [];

  const pendingCount = fillings.filter(
    (item) => item.status === "IN_PROGRESS",
  ).length;

  const completedCount = fillings.filter(
    (item) => item.status === "COMPLETED",
  ).length;

  const columns = [
    {
      name: "Quarter / Entity",
      selector: (row) => row,
      cell: (row) => (
        <div className="d-flex gap-2 pt-3 pb-3">
          <Truck size={18} className="text-primary mt-1" />
          <div>
            <div className="fw-bold text-primary">
              {row.vehicle || "All Fleet"}
            </div>
            <div className="small text-muted">
              {row.year} {QUARTERS.find((q) => q.id === row.quarter)?.label}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },

    {
      name: "Year",
      selector: (row) => row.year,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 text-muted pt-3 pb-3">
          <CalendarDays size={16} />
          <span>{row.year}</span>
        </div>
      ),
      sortable: true,
    },

    {
      name: "Period",
      selector: (row) => row,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 text-muted pt-3 pb-3">
          <CalendarRange size={16} />
          <span className="fst-italic">
            {getQuarterDateRange(row.quarter?.toString(), row.year?.toString())}
          </span>
        </div>
      ),
    },
   
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 pt-3 pb-3">
          <span
            className={`badge rounded-pill d-flex gap-2 align-items-center ${
              row.status === "COMPLETED"
                ? "bg-success-subtle text-success"
                : "bg-warning-subtle text-warning"
            }`}
          >
            {row.status === "COMPLETED" ? (
              <CheckCircle size={16} className="text-success" />
            ) : (
              <Clock size={16} className="text-warning" />
            )}
            {row.status}
          </span>
        </div>
      ),
      sortable: true,
    },

    {
      name: "Action",
      button: true,
      cell: (row) => (
        <ChevronRight
          size={20}
          className="cursor-pointer text-muted "
          onClick={(e) => {
            e.stopPropagation();
            handleReportClick(row);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <PageHeader
        name="IFTA Compliance"
        description="Manage fuel tax filings and driver reports."
      />

      <div className="container-fluid  main-container ">
        {/* Header */}
        <div class="bg-white py-5 px-4">
          <div className="row g-3 mb-4 mt-2">
            {[
              {
                label: "Pending Reports",
                val: pendingCount,
                color: "primary",
              },
              {
                label: "Completed Report",
                val: completedCount,
                color: "warning",
              },
            ].map((stat, i) => (
              <div className="col-md-6" key={i}>
                <div
                  className={`card border-start  custom-border border-5 border-${stat.color} shadow-sm`}
                >
                  <div className="card-body">
                    <div className="small text-muted text-uppercase fw-bold">
                      {stat.label}
                    </div>
                    <div className="h3 fw-bold mb-0">{stat.val}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="card-header w-100 p-0 pb-3">
            <div className="row w-100 m-0">
              <div className="col-auto p-0 d-flex ms-2">
                <Button
                  className="btn btn-primary d-flex align-items-center mt-0 mt-sm-0"
                  onClick={() => setShowModal(true)}
                >
                  <Plus className="me-2" size={16} />
                  New Filing
                </Button>
              </div>
              <div className="col-auto p-0 ms-2">
                <Button
                  className="btn btn-primary  "
                  onClick={() => setOpen(!open)} // Toggle collapse
                  aria-controls="collapse-inputs"
                  aria-expanded={open}
                >
                  <i className="ri-filter-2-fill" />
                </Button>
              </div>
              <div className="col-lg-3 col-5 p-0 ms-auto">
                <div className="input-group m-0">
                  <span
                    className="input-group-text bg-transparent border text-primary"
                    id="basic-addon1"
                  >
                    <i className="ri-search-line" />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search Here..."
                    aria-describedby="basic-addon1"
                    value={searchQuery}
                    onKeyUp={(e) => onSearchKeyHandler(e)}
                    onChange={(e) => setSearchQuery(e.target?.value)}
                  />
                </div>
              </div>
              <p className="text-muted small pt-2 mb-1">
                This Calculator aims to provide estimations based on standard
                IFTA-101 logic. Rates used are illustrative 2025 Q4 samples.
                Official returns should verify rates with IFTA Inc.
              </p>
            </div>
          </div>
          <Collapse in={open}>
            <div className="w-100">
              <Filter setQuery={setQuery} />
            </div>
          </Collapse>

          <div className="card border-0 shadow-sm mt-3">
            <div className="card-body">
              <CustomPagination
                isFetching={isFetching}
                data={filling}
                total={total}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerPageChange}
                paginationDefaultPage={currentPage}
                columns={columns}
                onRowClicked={handleReportClick}
                // highlightOnHover
                pointerOnHover
              />
            </div>
          </div>
        </div>

        {showModal && (
          <IftaModal
            show={showModal}
            onClose={() => setShowModal(false)}
            onCreate={handleCreate}
            tractors={tractors}
          />
        )}
      </div>
    </>
  );
}
